import React, { useState } from 'react';
import { Card, Input, Button } from '../../components/ui';
import { AlertTriangle, TrendingUp, Users } from 'lucide-react';
import { cn } from '../../lib/utils';

export function BreakEvenCalculatorTool() {
  const [fixedCosts, setFixedCosts] = useState('5000');
  const [pricePerUnit, setPricePerUnit] = useState('100');
  const [variableCostPerUnit, setVariableCostPerUnit] = useState('25');

  const fCost = parseFloat(fixedCosts) || 0;
  const pUnit = parseFloat(pricePerUnit) || 0;
  const vCostUnit = parseFloat(variableCostPerUnit) || 0;

  const contributionMargin = pUnit - vCostUnit;
  const breakEvenUnits = contributionMargin > 0 ? Math.ceil(fCost / contributionMargin) : 0;
  const breakEvenRev = breakEvenUnits * pUnit;

  return (
    <div className="grid lg:grid-cols-2 gap-8 text-left">
      <div className="space-y-6">
        <Card className="p-6 space-y-4">
          <h3 className="text-lg font-bold">Event or Product Costing</h3>
          <div>
            <label className="text-[10px] uppercase font-bold text-gray-400">Total Fixed Costs ($)</label>
            <Input type="number" value={fixedCosts} onChange={e => setFixedCosts(e.target.value)} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Ticket/Unit Price ($)</label>
              <Input type="number" value={pricePerUnit} onChange={e => setPricePerUnit(e.target.value)} />
            </div>
            <div>
              <label className="text-[10px] uppercase font-bold text-gray-400">Variable Cost/Unit ($)</label>
              <Input type="number" value={variableCostPerUnit} onChange={e => setVariableCostPerUnit(e.target.value)} />
            </div>
          </div>
        </Card>
      </div>

      <div className="space-y-6">
        <Card className="p-6 bg-emerald-50 border-emerald-100 flex flex-col justify-center dark:bg-emerald-900/20 dark:border-emerald-800 h-full text-center">
            <span className="text-[10px] uppercase font-bold text-emerald-600 block mb-2 tracking-widest">Break-Even Point</span>
            <div className="space-y-2">
              <p className="text-6xl font-black text-emerald-700 font-mono">{breakEvenUnits}</p>
              <p className="text-sm font-bold text-emerald-800/60 uppercase">Units / Tickets to Sell</p>
            </div>
            <div className="mt-8 border-t border-emerald-200/50 pt-4 dark:border-emerald-800/50">
              <span className="text-xs text-emerald-700/80">Break-Even Revenue: <strong className="font-mono">${breakEvenRev.toFixed(0)}</strong></span>
            </div>
        </Card>
      </div>
    </div>
  );
}

